import { OutlinedButton } from '../../util/button';
import './estimateDetailItemCard.css';

import {
  EstimateDetailInfoType,
  EstimateDetailItemType,
} from '@/types/bodyAndPaint';

interface EstimateDetailItemCardProps {
  info: EstimateDetailInfoType;
  onClick: () => void;
}
export const EstimateDetailItemCard = ({
  info,
  onClick,
}: EstimateDetailItemCardProps) => {
  const handleClickButton = () => onClick();

  const EstimateItem = ({ infoItem }: { infoItem: EstimateDetailItemType }) => {
    const { name, repair_amount, applied_amount, is_insurance } = infoItem;
    const repairAmount = repair_amount.toLocaleString('ja-JP') + '円';
    const appliedAmount = applied_amount.toLocaleString('ja-JP') + '円';
    const style = is_insurance ? 'applied' : 'no-apply';
    const isInsurance = is_insurance ? '保険適用可' : '保険適用不可';
    return (
      <div className={'estimate-detail-item'}>
        <div className={'item-header'}>
          <div className={'header-label'}>
            <span>{name}</span>
          </div>
          {is_insurance && (
            <div className={`estimate-status ${style}`}>
              <span>{isInsurance}</span>
            </div>
          )}
        </div>
        <div className={'item-body'}>
          <div className={`repair-amount ${style}`}>
            <span>{repairAmount}</span>
          </div>
          {is_insurance && (
            <div className={'applied-amount'}>
              <span>{appliedAmount}</span>
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className={'estimate-detail-item-field'}>
      <div className={'estimate-detail-item-header'}>
        <div className={'header-label'}>
          <span>{'見積もり詳細'}</span>
        </div>
        <div className={'header-button'}>
          <OutlinedButton
            onClick={handleClickButton}
            label={'修理箇所の画像を確認'}
          />
        </div>
      </div>
      <div className={'estimate-detail-item-body'}>
        <div className={'estimate-detail-item-card'}>
          {info?.map((item, idx) => (
            <EstimateItem infoItem={item} key={idx} />
          ))}
        </div>
      </div>
    </div>
  );
};
